import { Component } from 'react';

type Props = {
  className: string;
};

export default class VideoIcon extends Component<Props> {
  render() {
    return (
      <svg
        className={this.props.className}
        width="25"
        height="25"
        viewBox="0 0 28 28"
      >
        <path
          fill="white"
          d="M0 8.73V20a8 8 0 008 8h12a8 8 0 008-8V8.73zm18.18 10.19L12 22.51a1.13 1.13 0 01-1.67-1v-7.19a1.12 1.12 0 011.67-1l6.16 3.58a1.19 1.19 0 01.02 2.02zM27.8 6.23A8 8 0 0020 0h-2.14l3.72 6.23zM5.46.42A8 8 0 00.2 6.23h8.72zM18.66 6.23L14.95 0H8.12l3.72 6.23h6.82z"
        ></path>
      </svg>
    );
  }
}
